<template>
  <div>
    <div class="task-content-wrap" v-for="(item, index) in taskData" :key="index">
      <div class="task-content-detail"  @click="goTaskDetail(item)">
        <div class="task-content">
          <div class="task-name" :title="item.name">{{item.name}}</div>
          <div class="detail-content">
            <div class="detail-content-info">
              <div class="matter-info text">
                <span :title="item.matterName + '-' + item.taskGroupName" v-if="item.matterName && item.taskGroupName">{{item.matterName}}-{{item.taskGroupName}}</span>
                <span :title="item.matterName" v-if="item.matterName && !item.taskGroupName">{{item.matterName}}</span>
                <span v-if=" !item.matterName">个人任务</span>
              </div>
              <div class="check-list" v-if="item.itemCount">
                <i class="ibass ibass-list"></i>
                <span class="text">{{ item.completedItemCount }}/{{ item.itemCount }}</span>
              </div>
              <div class="comment-info" v-if="item.commentCount">
                <i class="ibass ibass-comment"></i>
                <span class="text">{{ item.commentCount }}</span>
              </div>
              <div class="attachment-info" v-if="item.attachmentCount">
                <i class="ibass ibass-attachment"></i>
                <span class="text">{{ item.attachmentCount }}</span>
              </div>
            </div>
            <div
              class="task-time"
              :class="{
                'overtimeColor': item.isOvertime
              }"
            >
              <span v-if="item.formatDueTime">{{item.formatDueTime}} 到期</span>
              <span v-if="item.endTime">{{item.endTime}} 结束</span>
            </div>
          </div>
        </div>
        <div class="task-member">
          <div class="image-container">
            <user-pic-list
              :maxLength="2"
              :users="item.attendees"
              :props="{ 'id': 'id', 'pic': 'avatar' }"
            />
            <!--<img v-for="member in item.attendees" :key="member.id" class="head-icon" :src="member.avatar"/>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import PermissionService from '../../../service/authority'
// import timeUtils from '@/utils/time'
import UserPicList from '@/components/task-filter-group/UserPicList'
export default {
  name: 'TodoTask',
  props: {
    taskData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    UserPicList
  },
  data () {
    return {
      // isOvertime: '',
      matterId: ''
      // loading: false
      // taskData: []
    }
  },
  methods: {
    goTaskDetail (task) {
      this.$postMessage.openTaskDetail(task.id)
      this.$analysis.track('查看任务详情_待办事项/工作台模块')
    },
    addNewTask () {
      this.$postMessage.createTask((data) => {
        if (data && data.isSuccess === true) {
          this.getApproLists()
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .task-content-wrap {
    width 100%;
    /*min-height 300px;*/
    display flex;
    justify-content space-between;
    align-items center;
    border-bottom 1px solid #f1f2f3;
    box-sizing border-box;

    .task-content-detail {
      width 100%;
      display flex;
      justify-content space-between;
      align-items center;
      flex-grow 1;
      cursor pointer;
      .ibass {
        margin-right 5px
        color rgba(133, 144, 166, 0.3)
        font-size 16px
        vertical-align middle
      }
      .ibass-attachment:before {
        transform rotate(45deg)
      }
      .task-content {
        display flex;
        flex-direction column;
        justify-content center;

        .task-name {
          max-width 500px;
          height 24px;
          font-size 16px;
          color #000000;
          margin-bottom 8px;
          text-overflow ellipsis;
          overflow hidden;
          white-space nowrap;
          &:hover {
            color #ed6c00
          }
        }

        .detail-content {
          width 550px;
          display -webkit-box;
          align-items center;
          justify-content space-between;
          font-size 12px;
          color #8590A6;
          .detail-content-info {
            display block;
            width 380px;
            display flex;
            align-items center;
            /*justify-content space-between;*/
            margin-right 35px;
            .matter-info {
              display inline-block;
              width 180px;
              overflow hidden;
              text-overflow ellipsis;
              white-space nowrap
              /*margin-right 30px;*/
              cursor pointer;
            }
            .check-list {
              display inline-block;
              margin-left 30px;
              width 45px;
            }
            .comment-info {
              display inline-block;
              margin-left 30px;
              width 35px;
            }
            .attachment-info {
              display inline-block;
              margin-left 30px;
              width 35px;
            }
          }
          .task-time {
            text-align left;
            width 150px;
            margin-right 40px
            &.overtimeColor {
              color #f72b44
            }
          }

        }
      }
    }
    .task-member {
      padding 20px 0
      max-width 200px;
      display flex

      .image-container {
        padding-right 33px;

        .head-icon{
          width 32px;
          height 32px;
          border-radius 16px;
          background-color #f3f3f3;

        }
      }
      .one-more {
        /*background #8590A6;*/

      }
    }
  }

</style>
